import { IstariV3Client } from "@istari/istari-client";

import { browserTransferOptions, currentRegistryToken } from "./browser-transfer";
import { invokeWithCurrentToken } from "./client-invocation";
import { identityClientOptions } from "./identity-client-options";
import { resolveRegistryTarget } from "./registry-target";

const getClientV3SDK = (onToken?: (token: string | undefined) => void) => {
  const target = resolveRegistryTarget();
  const options = {
    registryAuthToken: onToken
      ? async () => {
          const token = await currentRegistryToken();
          onToken(token);
          return token;
        }
      : currentRegistryToken,
    transfer: browserTransferOptions,
    ...identityClientOptions(),
  };
  return new IstariV3Client(
    target.kind === "gateway"
      ? { digitalApiUrl: target.digitalApiUrl, ...options }
      : { registryUrl: target.registryUrl, ...options },
  );
};

const clientV3SDK = new Proxy({} as IstariV3Client, {
  get(target, prop) {
    const client = getClientV3SDK();
    const value = client[prop as keyof IstariV3Client];
    if (typeof value === "function") {
      return (...args: unknown[]) => invokeWithCurrentToken(getClientV3SDK, prop as keyof IstariV3Client, args);
    }
    return value;
  },
});

export default clientV3SDK;
